import React, { useState } from "react";
import PedidoList from "./PedidoList";
import PedidoDetalle from "./PedidoDetalle";

function PedidosPage() {
  const [pedidoSeleccionado, setPedidoSeleccionado] = useState(null);

  return (
    <div className="container mt-4">
      {pedidoSeleccionado ? (
        <PedidoDetalle
          pedido={pedidoSeleccionado}
          onClose={() => setPedidoSeleccionado(null)}
        />
      ) : (
        <PedidoList onSelectPedido={setPedidoSeleccionado} />
      )}
    </div>
  );
}

export default PedidosPage;
